export const LYWORKFLOW_VERSION = '1.0.1'